import { SKU_UPLOAD_STATUS } from 'Data/constants';
export const getStatusMessage = value => {
	let message = '';
	switch (value) {
		case SKU_UPLOAD_STATUS.UPLOADING:
			message = 'Data uploading is in progress.';
			break;
		case SKU_UPLOAD_STATUS.SKUDATAUPLOADFAILED:
			message = 'Data uploading failed. Please try uploading again.';
			break;
		case SKU_UPLOAD_STATUS.UPLOADED:
			message = 'Data is uploaded.';
			break;
		case SKU_UPLOAD_STATUS.VALIDTING:
			message = 'Data validation is in progress.';
			break;
		case SKU_UPLOAD_STATUS.SKUDATAVALIDATIONFAILED:
			message = 'Data validation failed. Please try uploading again.';
			break;
		case SKU_UPLOAD_STATUS.VALIDATED:
			message = 'Data is validated.';
			break;
		case SKU_UPLOAD_STATUS.PIPELINESTARTING:
			message = 'Pipeline Starting';
			break;
		case SKU_UPLOAD_STATUS.DATACOPY:
			message = 'Transfering Data ADLS to SQL';
			break;
		case SKU_UPLOAD_STATUS.DATAPUBLISHED:
			message = 'File published successfully.';
			break;
		case SKU_UPLOAD_STATUS.ERRORSTATE:
			message = 'Error Occured';
			break;
		default:
			message = 'Pipeline Running';
	}
	return message;
};
